import React, { Component } from "react"
import { Themes } from "../managers/ThemeManager"
import { deregister } from "../services"
import { withPermissions } from "../components/AuthenticationComponent"
import { Constants } from "../Constants"
import OmniAural from "omniaural"
import { SuccessfulRegistrationBanner } from "../components/SuccessFulRegistration"
import { Header } from "./screen-components/PageHeader"
import { ContactInfoText } from "../components/ContactInfoText"
import { DeviceInfoCard } from "../components/DeviceInfoCard"
import "./Registered.css"
import ContentModal from "../components/ContentModal"

class Registered extends Component {
  state = {
    expandedDeregisteredDevice: false
  }

  constructor(props) {
    super(props)
    OmniAural.register(this, "user")
  }

  deregisterDevice = (deviceId) => {
    if (deviceId) {
      deregister({
        device_id: deviceId,
        registration_key: OmniAural.state.user.registration_key?.value()
      })
        .then(() => {
          //reload page
          window.location.reload()
        })
        .catch((e) => {
          console.log("Error occurred while attempting to deregister: ", e)
        })
    }
  }

  toggleEexpandDeregisteredDevice = () => {
    this.setState({ expandedDeregisteredDevice: !this.state.expandedDeregisteredDevice })
  }

  goToRegistration = () => {
    // Go to registration page but pass a newDevice flag to indicate that this is a new device
    this.props.history.push({
      pathname: "/register_pfa",
      state: { newDevice: true }
    })
  }

  renderFAQItem = (question, answer) => {
    return (
      <div key={question}>
        {question && <p className="bold subhead">{question}</p>}
        {answer && (
          <p>
            {answer.replace("#contact-info", OmniAural.state?.config?.helpdesk_contact?.value())}
          </p>
        )}
      </div>
    )
  }

  render() {
    const { history } = this.props
    const images = Themes.currentTheme().images
    const devices = OmniAural.getAllUserDevices()
    const userFirstName = OmniAural.state.user.first_name?.value() || ""
    const userLastName = OmniAural.state.user.last_name?.value() || ""
    const uid = OmniAural.state.user.uid?.value() || ""
    const mostRecentDeregisteredDevice = devices.find((device) => {
      return !!device.deregistered_at
    })
    const { user } = this.state

    return (
      <div>
        <Header />
        <img src={images.appHeroImage} className="app-hero-image" alt="app hero" />
        <SuccessfulRegistrationBanner
          description={Themes.currentTheme().strings.register_success_message}
        />
        <div className="body-container">
          <div className="body-container-head">
            <h1 style={{ textTransform: "capitalize", marginBottom: "0px" }}>Welcome, {userFirstName} {userLastName}</h1>
            <p style={{ fontSize: "14px" }}>UID: {uid}</p>
            <h2>Your registered device(s)</h2>
            <p>Need to reinstall the app? Simply deregister first, and then reregister.</p>
          </div>
          <div className="body-container-body">
            <div className="body-container-body-item">
              <div className="card-container">
                {devices.map((device) => {
                  if (device.deregistered_at) {
                    return null
                  }
                  return (
                    <DeviceInfoCard
                      key={device.device_id}
                      device={device}
                      showMFALabel
                      isDefaultDevice={user.default_device_id === device.device_id}
                      userRegistrationKey={user.registration_key}
                      onDeregister={(deviceToDeregister) =>
                        OmniAural.showModal({
                          data: deviceToDeregister,
                          type: "deregister",
                          onConfirm: this.deregisterDevice
                        })
                      }
                    />
                  )
                })}
              </div>
              {mostRecentDeregisteredDevice && (
                <p
                  onClick={this.toggleEexpandDeregisteredDevice}
                  className="text-link no-underline">
                  View most recently deregistered device
                  <span style={{ fontSize: 12, paddingLeft: 10 }}>
                    {this.state.expandedDeregisteredDevice ? "▲" : "▼"}
                  </span>
                </p>
              )}
              {this.state.expandedDeregisteredDevice && (
                <div className="card-container">
                  <DeviceInfoCard device={mostRecentDeregisteredDevice} />
                </div>
              )}
            </div>
            <div className="body-container-body-item">
              <button type="button" className="register-button" onClick={this.goToRegistration}>
                <p>REGISTER ANOTHER DEVICE</p>
              </button>
              <span>
                {`Issues with the ${Themes.currentTheme().strings.appName} service?`}
                <ContactInfoText />
              </span>
            </div>
            <div className="body-container-body-item">
              <h2>
                {Themes.currentTheme().strings.registered_faq_title.replace(
                  "#app-name",
                  Themes.currentTheme().strings.appName
                )}
              </h2>
              <p className="italic">
                {Themes.currentTheme().strings.registered_faq_subtitle.replace(
                  "#app-name",
                  Themes.currentTheme().strings.appName
                )}
              </p>

              {this.renderFAQItem(
                Themes.currentTheme().strings.service_question_01_question,
                Themes.currentTheme().strings.service_question_01_answer.replace(
                  "#contact-info",
                  OmniAural.state?.config?.helpdesk_contact?.value()
                )
              )}
              {this.renderFAQItem(
                Themes.currentTheme().strings.service_question_02_question,
                Themes.currentTheme().strings.service_question_02_answer
              )}
              {this.renderFAQItem(
                Themes.currentTheme().strings.service_question_03_question,
                Themes.currentTheme().strings.service_question_03_answer
              )}
            </div>
            <div className="body-container-body-item">
              <p
                className="text-link"
                onClick={() => {
                  history.push({
                    pathname: "/faq"
                  })
                }}>
                View all FAQs
              </p>
            </div>
            <div className="body-container-body-item">
              <p
                className="text-link"
                onClick={() => {
                  history.push({
                    pathname: "/terms"
                  })
                }}>
                End User License Agreement and Terms & Conditions
              </p>
            </div>
            <div className="body-container-body-item">
              <p
                className="text-link"
                onClick={() => {
                  window.location.replace("/logout")
                }}>
                Log out
              </p>
            </div>
          </div>
        </div>
        <ContentModal />
      </div>
    )
  }
}

export default withPermissions(Registered, [
  Constants.PERMISSION_TYPES.AUTHENTICATED,
  Constants.PERMISSION_TYPES.PFA_REGISTERED
])
